import angular from 'angular';

let AnchorModal = ($uibModal) => {

    let service = {};

    service.open = (section) => {

        $uibModal.open({
            animation: true,
            template: require('./anchorModal.html'),
            size: 'md',
            controllerAs: 'vm',
            controller: ($uibModalInstance) => {
                let vm = {};
                vm.section = section;

                vm.change = () => {
                    if (vm.section.config.anchor.title) {
                        vm.section.config.anchor.visible = true;
                    }

                    $uibModalInstance.close();
                };

                return vm;
            }
        });
    };

    return service;
};

/**
 * Service providing change password modal.
 * @namespace cms.password.change
 */
export default angular.module('cms.creator.anchor.modal', []).factory('AnchorModal', AnchorModal).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/Workspace/AnchorModal/AnchorModal.js